import React from 'react';
import { Compass, Ruler, ShieldCheck, Timer } from 'lucide-react';
import { trustPoints } from '../data/site';
import { Reveal } from './Reveal';
const icons = [Ruler, Timer, Compass, ShieldCheck];
export function TrustBar() {
  return <section aria-label="Why homeowners trust Pure Build Construction" className="w-full border-b border-mist-200 bg-white" data-id="element-392" data-mp="yaag3s2b1vo4">
      <div className="mx-auto grid max-w-[1400px] grid-cols-2 divide-mist-200 px-5 sm:px-8 lg:grid-cols-4 lg:divide-x" data-id="element-393" data-mp="135fywi0euu7z">
        {trustPoints.map((point, i) => {
        const Icon = icons[i];
        return <Reveal key={point} delay={i * 0.08} className="flex items-center gap-4 py-8 lg:px-8 lg:first:pl-0" data-id="element-394" data-mp="1gzh1jmuhh1dm" data-mpi={i}>
              <Icon className="h-6 w-6 shrink-0 text-brand-500" strokeWidth={1.4} aria-hidden="true" data-id="element-395" data-mp="1lxs9fs17x1t7" />
              <span className="font-heading text-[12px] font-bold uppercase leading-tight tracking-[0.16em] text-navy sm:text-sm" data-id="element-396" data-mp="5jsekvh8c2ct">
                {point}
              </span>
            </Reveal>;
      })}
      </div>
    </section>;
}